import _ from "lodash";

import { ConditionReport } from "@skinsoft/types";

export function cleanConditionReportBeforePush(conditionReport: ConditionReport): Partial<ConditionReport> {
    let res: Partial<ConditionReport> = {}

    if(conditionReport.associatedMedias) {
        const associatedMedias = conditionReport.associatedMedias

        if(associatedMedias.first !== undefined) {
            _.set(res, "associatedMedias.first", associatedMedias.first)
        }
        if(associatedMedias.second !== undefined) {
            _.set(res, "associatedMedias.second", associatedMedias.second)
        }
        if(associatedMedias.third !== undefined) {
            _.set(res, "associatedMedias.third", associatedMedias.third)
        }

        if(associatedMedias.medias !== undefined) {
            _.set(res, "associatedMedias.medias", associatedMedias.medias)
        }
    }

    if(conditionReport.conditionReportCS) {
        const conditionReportCS = conditionReport.conditionReportCS

        // @ts-ignore
        if(conditionReportCS.reportType !== undefined) {
            // @ts-ignore
            _.set(res, 'conditionReportCS.reportType', conditionReportCS.reportType)
        }

        // @ts-ignore
        if(conditionReportCS.location !== undefined) {
            // @ts-ignore
            _.set(res, 'conditionReportCS.location', conditionReportCS.location)
        }

        if(conditionReportCS.reportReason !== undefined) {
            _.set(res, 'conditionReportCS.reportReason', conditionReportCS.reportReason)
        }

        if(conditionReportCS.reportEditor !== undefined) {
            _.set(res, 'conditionReportCS.reportEditor', conditionReportCS.reportEditor)
        }

        if(conditionReportCS.signers !== undefined) {
            _.set(res, 'conditionReportCS.signers', conditionReportCS.signers)
        }

        if(conditionReportCS.stateOfConservations !== undefined) {
            _.set(res, 'conditionReportCS.stateOfConservations', conditionReportCS.stateOfConservations)
        }

        if(conditionReportCS.predictInterventions !== undefined) {
            _.set(res, 'conditionReportCS.predictInterventions', conditionReportCS.predictInterventions)
        }

        if(conditionReportCS.counterSignatures !== undefined) {
            _.set(res, 'conditionReportCS.counterSignatures', conditionReportCS.counterSignatures)
        }

        if(conditionReportCS.alterations !== undefined) {
            _.set(res, 'conditionReportCS.alterations', conditionReportCS.alterations)
        }
    }

    if(conditionReport.conditioningSchema) {
        if(conditionReport.conditioningSchema.crateNumber !== undefined) {
            _.set(res, "conditioningSchema.crateNumber", conditionReport.conditioningSchema.crateNumber)
        }

        if(conditionReport.conditioningSchema.transportAccessories !== undefined) {
            _.set(res, "conditioningSchema.transportAccessories", conditionReport.conditioningSchema.transportAccessories)
        }

        if(conditionReport.conditioningSchema.typeOfPackaging !== undefined) {
            _.set(res, "conditioningSchema.typeOfPackaging", conditionReport.conditioningSchema.typeOfPackaging)
        }
    }

    if(conditionReport.workflowSchema?.currentState?.name !== undefined) {
        _.set(res, 'workflowSchema.currentState.name', conditionReport.workflowSchema.currentState.name)
    }

    return res
}